import { render } from "./h-pagination.vue?vue&type=template&id=e993c6bc&ts=true"
import script from "./h-pagination.ts?vue&type=script&lang=ts"
export * from "./h-pagination.ts?vue&type=script&lang=ts"

import "./h-pagination.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__